module.exports = __webpack_public_path__ + "img/rank.f7cae76f.png";